//import logger from '../services/logger';

import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import AuthService from "../services/auth.service";
import { Onboarding2 } from "./common/Icon";

import { Link } from "react-router-dom";

const checkPasswordRules = (password) => {
    return {
      length: /.{8,}/.test(password),
      lowercaseUppercase: /(?=.*[a-z])(?=.*[A-Z])/.test(password),
      digit: /(?=.*\d)/.test(password),
      specialChar: /(?=.*[@$!%*?&])/.test(password),
    };
  };

  const validatePassword = (value) => {
    const passwordRules = [
      {
        rule: /.{8,}/,
        message: "au moins 8 caractères.",
      },
      {
        rule: /(?=.*[a-z])(?=.*[A-Z])/,
        message: "au moins une lettre majuscule et une lettre minuscule.",
      },
      {
        rule: /(?=.*\d)/,
        message: "au moins un chiffre.",
      },
      {
        rule: /(?=.*[@$!%*?&])/,
        message: "au moins un caractère spécial (@$!%*?&).",
      },
    ];
  
    const errors = passwordRules
      .filter((rule) => !rule.rule.test(value))
      .map((rule) => rule.message);
  
    if (errors.length > 0) {
      return `Votre mot de passe doit contenir :<br />- ${errors.join("<br />- ")}`;
    }
    return null;
  };

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [successful, setSuccessful] = useState(false);

  const [passwordRulesState, setPasswordRulesState] = useState({
      length: false,
      lowercaseUppercase: false,
      digit: false,
      specialChar: false,
    });

  const token = searchParams.get("token");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setSuccessful(false);
    
    const passwordError = validatePassword(password);
    if (passwordError) {
        setMessage(passwordError);
        return;
    }
    
    if (password !== confirmPassword) {
      setMessage("Les mots de passe ne correspondent pas.");
      return;
    }

    

    try {
      await AuthService.resetPassword({ token, newPassword: password });
      setMessage("Votre mot de passe a bien été réinitialisé !");
      setSuccessful(true);

      setTimeout(() => navigate("/login"), 3000); // redirection après succès
    } catch (error) {
      const resMessage =
        (error.response?.data?.message) || error.message || "Erreur inattendue.";
      setMessage(resMessage);
    }
  };

  return (
    <div style={{ position: 'absolute', top: '0', left: '0', backgroundColor: 'white', minHeight: '100vh', width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div className="col-12 col-lg-6 mx-auto" style={{ padding: '20px', maxWidth: "992px" }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img
            src={process.env.PUBLIC_URL + 'icons/Logo_dcare.svg'}
            alt="Logo de DCARE"
            style={{ width: "200px" }}
          />
        </div>
        <br />
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div className="mt-3" style={{ maxWidth: '384px' }}>
            <div role="form" aria-labelledby="reset-password-form-title">
              <h1 id="reset-password-form-title" className="text-left mb-1" style={{ fontSize: '1.25em', fontWeight: '700' }}>Nouveau mot de passe</h1>
              <p style={{ fontSize: '1em', fontWeight: '400' }}>
                Choisissez un nouveau mot de passe pour accéder à votre compte.
              </p>

              {message && (
                <div className="form-group">
                  <div
                    className={successful ? "alert alert-success" : "error-message"}
                    role="alert"
                    aria-live="assertive"
                    dangerouslySetInnerHTML={{ __html: message }}
                  />
                </div>
              )}

              {!successful && (
                <form onSubmit={handleSubmit} className="mt-4">
                    <input
                    type="text"
                    name="username"
                    autoComplete="username"
                    style={{ display: "none" }}
                    tabIndex={-1}
                    />
                  <div className="form-group">
                    <label htmlFor="password">Nouveau mot de passe</label>
                    <input
                      type="password"
                      id="password"
                      className="form-control"
                      value={password}
                      onChange={(e) => {
                        const value = e.target.value;
                        setPassword(value);
                        setPasswordRulesState(checkPasswordRules(value));
                      }}
                      placeholder="Entrez le nouveau mot de passe"
                      required
                      autoComplete="new-password"
                    />
                  </div>
                  <ul style={{ 
                    fontSize: '0.75em', 
                    fontWeight: '300', 
                    marginTop: '0.5rem', 
                    paddingLeft: '1.25rem',
                    fontStyle: 'italic' // ← texte en italique
                  }}>
                    <li style={{ color: passwordRulesState.length ? 'green' : 'black' }}>
                      {passwordRulesState.length ? '✓' : ''} Au moins 8 caractères
                    </li>
                    <li style={{ color: passwordRulesState.lowercaseUppercase ? 'green' : 'black' }}>
                      {passwordRulesState.lowercaseUppercase ? '✓' : ''} Majuscule et minuscule
                    </li>
                    <li style={{ color: passwordRulesState.digit ? 'green' : 'black' }}>
                      {passwordRulesState.digit ? '✓' : ''} Au moins un chiffre
                    </li>
                    <li style={{ color: passwordRulesState.specialChar ? 'green' : 'black' }}>
                      {passwordRulesState.specialChar ? '✓' : ''} Un caractère spécial (@$!%*?&)
                    </li>
                  </ul>

                  <div className="form-group">
                    <label htmlFor="confirmPassword">Confirmez le mot de passe</label>
                    <input
                      type="password"
                      id="confirmPassword"
                      className="form-control"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      placeholder="Confirmez le mot de passe"
                      required
                      autoComplete="new-password"
                    />
                  </div>

                  <div className="mt-4 form-group">
                    <button
                      type="submit"
                      className="btn-primary btn-block"
                      aria-label="Réinitialiser le mot de passe"
                      style={{ width: '100%' }}
                    >
                      Réinitialiser
                    </button>
                    <div className="mt-2 text-center">
                        <span style={{ fontSize: '0.875rem' }}>Vous avez retrouvé votre mot de passe ? </span>
                        <Link to={"/login"} className='text-medium' style={{ color: 'var(--color-green)', textDecoration: 'none', paddingRight: '10px' }}>Se connecter</Link>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-6 d-none d-lg-block h-100" style={{ overflow: 'hidden' }}>
        <Onboarding2
          style={{
            height: '100%',
            width: '100%',
            objectFit: 'cover',
            clipPath: "polygon(10% 0%, 100% 0, 100% 100%, 0% 100%)"
          }}
        />
      </div>
    </div>
  );
};

export default ResetPassword;
